import Dashboard from "layouts/dashboard";
import Welcome from "layouts/welcome";
// import Tables from "layouts/tables";

import Virement from "layouts/virement/virement";
import Tables from "layouts/tables/Tables.jsx";
// import Billing from "layouts/billing";
// import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
// import SignUp from "layouts/authentication/sign-up";

// @mui icons
import Icon from "@mui/material/Icon";
import AdminSegment from "layouts/tables/AdministrativeSegment.jsx";
import EconomicSegment from "layouts/tables/EconomicSegemnt.jsx";
import FunctionalSegment from "layouts/tables/FunctionalSegment.jsx";
import ProgramSegment from "layouts/tables/ProgramSegment.jsx";
import FundSegment from "layouts/tables/FundSegment.jsx";
import GeoSegment from "layouts/tables/GeoSegment.jsx";
import SegmentForm from "layouts/tables/Segment.jsx";
import Report from "layouts/tables/Report.jsx";

import CreatUser from "layouts/tables/CreateUser.jsx";
import ManageUser from "layouts/tables/ManageUsers.jsx";
import AuditTrail from "layouts/audit/AuditTrail.jsx";
import SubSubOrg from "layouts/tables/SubSubOrg.jsx";
import SubSubSubOrg from "layouts/tables/SubSubSub.jsx";
import Revised from "layouts/tables/Revised.jsx";
import Supplemetary from "layouts/tables/Supplementary.jsx";
import Approved from "layouts/tables/Approved.jsx";
import HouseRecom from "layouts/tables/HouseREcom.jsx";
import EXCO from "layouts/tables/Exco.jsx";
import MOPB from "layouts/tables/Mopb.jsx";
import AdminMapping from "layouts/tables/AdminMapping.jsx";
import EcoMapping from "layouts/tables/EconomicMapping.jsx";
import FuncMap from "layouts/tables/FunctionalMapping.jsx";
import ProgramMaping from "layouts/tables/ProgramMaping.jsx";
import FundMaping from "layouts/tables/FundMap.jsx";
import GeoMaping from "layouts/tables/GeoMapping.jsx";
import Proposedtable from "layouts/tables/ProposedTable.jsx";
import AgricultureSector from "examples/M&E/AgricultureSector.jsx";
import CommerceSector from "examples/M&E/CommerceSector.jsx";
import EducationSector from "examples/M&E/EducationSector.jsx";
import EnvironmentNaturalResourcesSector from "examples/M&E/EnvironmentNaturalResourcesSector.jsx";
import HealthSector from "examples/M&E/HealthSector.jsx";
import HousingandTransportSector from "examples/M&E/HousingandTransportSector.jsx";
import KanoStateMandE from "examples/M&E/KanoStateMandE.jsx";
import SampleMonitoring from "examples/M&E/SampleMonitoring.jsx";
import SectorBudgetCeiling from "layouts/tables/SectorBudgetCeiling.jsx";
import MDABudgetCelling from "layouts/tables/MDABudgetCelling.jsx";
import OtherSetup from "examples/admin/OtherSetup.jsx";
import BudgetView from "layouts/tables/BudgetView.jsx";
import ProfileNew from "examples/profile/Profile.jsx";
import ApprovedBudget from "layouts/tables/ApprovedBudget.jsx";

import EcoReport from "layouts/tables/reports/EcoReport.jsx";
import TotalRevenuebyEconomic from "layouts/tables/reports/TotalRevenuebyEconomic.jsx";
import ProgramReport from "layouts/tables/reports/ProgramReport.jsx";
import FundReport from "layouts/tables/reports/FundReport.jsx";
import GeoReport from "layouts/tables/reports/GeoReport.jsx";
import AdminQuaterly from "layouts/tables/reports/AdminQuertly.jsx";
import EcoQuaterly from "layouts/tables/reports/EcoQuarterly.jsx";
import FuncQuaterly from "layouts/tables/reports/FuncQuarterly.jsx";
import ProgramQuaterly from "layouts/tables/reports/ProgramQuart.jsx";
import FundQuaterly from "layouts/tables/reports/FundQuarterly.jsx";
import GeoQuaterly from "layouts/tables/reports/GeoQuarter.jsx";
import BudgetProposal from "layouts/tables/BudgetProposal.jsx";
import ReportByLoc from "layouts/tables/reports/ReportByLoc.jsx";
import ReportByFund from "layouts/tables/reports/ReportByFund.jsx";
import ReportByFunc from "layouts/tables/reports/ReportByFunc.jsx";
import BudgetOverview from "layouts/tables/reports/BudgetOverview.jsx";
import ReleaseCollection from "layouts/tables/ReleaseCollection.jsx";
import NewReleaseCollection from "layouts/tables/NewReleaseCollection.jsx";
import ReleaseCancellation from "layouts/tables/ReleaseCancellation.jsx";
import RecallRelease from "layouts/tables/RecallRelease.jsx";
import EditNewReleaseCollection from "layouts/tables/EditNewReleaseCollection.jsx";
import CcCopies from "layouts/tables/CcCopies.jsx";
import PlanningReserve from "layouts/tables/PlanningReserve.jsx";
import InternalAudit from "layouts/tables/InternalAudit.jsx";
import ApprovalReview from "layouts/tables/Aoroval_Reviewal.jsx";
import ReleaseUnclear from "layouts/tables/ReleaseUnclear.jsx";
import ViewRelease from "layouts/tables/ViewRelease.jsx";
import ReleaseReport from "layouts/tables/ReleaseReport.jsx";
import ReleaseView from "layouts/tables/ReleaseView.jsx";
import ReportByEco from "layouts/tables/reports/ReportByEco.jsx";
import PerformanceView from "components/Tree/PerformanceView.jsx";
import NewVirementRequest from "layouts/virement/NewVirement.jsx";
import NewVirementEntry from "layouts/virement/NewVirementEntry.jsx";
import PublicationReportsNew from "layouts/tables/reports/PublicationReportsNew.jsx";
import VirementTable from "layouts/virement/VirementTable.jsx";
import ContingencyReserve from "layouts/virement/ContingencyReserve.jsx";
import AIE from "layouts/tables/AIE.jsx";
import ExpByDepartment from "layouts/tables/reports/ExpByDepartment.jsx";
import BudgetBreakdown from "layouts/tables/BudgetBreakdown.jsx";
import RevenueReportsDash from "layouts/tables/reports/RevenueReportsDash.jsx";
import ExcelUpload from "examples/admin/UploadExcel.jsx";
import ContengencyTable from "layouts/tables/ConetengencyTable.jsx";
import AppropriationLaw from "layouts/tables/reports/AppropriationLaw.jsx";
import CapitalProjects from "layouts/tables/reports/CapitalProject.jsx";
import NewPlanningReserve from "layouts/tables/NewPlanningReserve.jsx";
import MonthlyRecurrent from "layouts/tables/MonthlyRecurrent.jsx";
import MonthlyRecurrentForm from "layouts/tables/MonthlyRecurrentForm.jsx";
import RevenueByMDA from "layouts/tables/reports/RevenueByMDA.jsx";
import BudgetPerformance from "layouts/tables/reports/BudgetPerformance.jsx";
import ChartOFAcctSetup from "layouts/tables/ChartOFAcctSetup.jsx";
import Reactivate from "layouts/tables/Reactivate.jsx";
import SignedApproval from "layouts/tables/SignedApproval.jsx";
import MemoList from "layouts/memo/MemoList.jsx";
import CreateMemo from "layouts/memo/CreateMemo.jsx";
import ViewMemo from "layouts/memo/ViewMemo.jsx";
import BudgetEntriesReport from "layouts/tables/reports/BudgetEntriesReport.jsx";
import Secretary from "layouts/memo/Secretary";
import Commissioner from "layouts/memo/Commissioner";
import PamSec from "layouts/memo/Pam-sec";
import Director from "layouts/memo/Director";
import InternalControl from "layouts/tables/InternalControl";
import FinalApproval from "layouts/tables/FinalApproval";
// const user = useSelector((e) => e.auth.user);
// alert(JSON.stringify(user))
const routes = [
  {
    type: "route",
    key: "welcome",
    route: "/welcome",
    component: <Welcome />,
  },
  {
    type: "collapse",
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "ccCopies",
    name: "CC_Copies",
    key: "CC_Copies",
    route: "/cccopies",
    con: <Icon fontSize="small">bar_chart</Icon>,
    component: <CcCopies />,
  },
  {
    type: "collapse",
    key: "profile",
    route: "/profile",
    component: <ProfileNew />,
  },
  {
    type: "collapse",
    name: "Account Chart",
    key: "chart",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/chart",
    component: <Tables />,
  },
  {
    type: "Virement",
    name: "Virement",
    key: "Virement",
    icon: <Icon fontSize="small">swap_horiz</Icon>,
    route: "/Virement",
    component: <Virement />,
  },
  {
    type: "Virement",
    name: "Review-Virement",
    key: "Review-Virement",
    icon: <Icon fontSize="small">rate_review</Icon>,
    route: "/Review-Virement",
    component: <Virement />,
  },
  {
    type: "Virement",
    name: "Approve-Virement",
    key: "Approve-Virement",
    icon: <Icon fontSize="small">check_circle</Icon>,
    route: "/Approve-Virement",
    component: <Virement />,
  },
  // {
  //   type: "Virement",
  //   name: "Planning Reserve",
  //   key: "PlanningReserve",
  //   icon: <Icon fontSize="small">P</Icon>,
  //   route: "/Virement/planning-reserve",
  //   component: <PlanningReserveForm />,
  // },
  {
    type: "BudgetAmend",
    name: "Contingency Reserve Recurrent",
    route: "contingency-table-recurerent",
    key: "contingency-table-recurrent",
    icon: <Icon fontSize="small">account_balance</Icon>,
    component: <ContengencyTable />,
  },
  {
    type: "BudgetAmend",
    name: "Contingency Reserve Capital",
    route: "contingency-table-capital",
    key: "contingency-table-capital",
    icon: <Icon fontSize="small">savings</Icon>,
    component: <ContengencyTable />,
  },
  {
    type: "BudgetAmend",
    name: "AIE",
    route: "contingency-table-aie",
    key: "contingency-table-aie",
    icon: <Icon fontSize="small">assignment</Icon>,
    component: <ContengencyTable />,
  },
  {
    // type: "BudgetAmend",
    // name: "Contingency Reserve Recurrent",
    // key: "contingency-reserve-recurrent",
    // icon: <Icon fontSize="small">C</Icon>,
    route: "contingency-reserve-recurrent",
    component: <ContingencyReserve />,
  },
  {
    // type: "BudgetAmend",
    // name: "Contingency Reserve Capital",
    // key: "contingency-reserve-capital",
    // icon: <Icon fontSize="small">C</Icon>,
    route: "contingency-reserve-capital",
    component: <ContingencyReserve />,
  },
  {
    type: "BudgetAmend",
    name: "Supplementary",
    key: "Supplementary",
    icon: <Icon fontSize="small"> star </Icon>,
    route: "/Supplementary",
    component: <Supplemetary />,
  },

  {
    // type: "BudgetAmend",
    // name: "AIE",
    // key: "aie",
    // icon: <Icon fontSize="small">event</Icon>,
    route: "/contingency-reserve-aie",
    component: <ContingencyReserve />,
  },
  {
    type: "collapse",
    name: "Administrative Segment",
    key: "admin",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/admin",
    component: <AdminSegment />,
  },
  {
    type: "collapse",
    name: "Economic Segment",
    key: "economic",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/economic",
    component: <EconomicSegment />,
  },
  {
    type: "collapse",
    name: "Functional Segment",
    key: "functional",
    icon: <Icon fontSize="small">money</Icon>,
    route: "/functional",
    component: <FunctionalSegment />,
  },
  {
    type: "collapse",
    name: "Programme Segment",
    key: "program",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/program",
    component: <ProgramSegment />,
  },
  {
    type: "collapse",
    name: "Fund Segment",
    key: "fund",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/fund",
    component: <FundSegment />,
  },
  {
    type: "collapse",
    name: "Geo Segment",
    key: "geo",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/geo",
    component: <GeoSegment />,
  },
  {
    type: "collapse",
    name: "Chart Of Account Setup",
    key: "chart-setup",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/chart-setup",
    component: <ChartOFAcctSetup />,
  },

  {
    type: "collapse",
    name: "Reactivate Accounts",
    key: "reactivate",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/reactivate",
    component: <Reactivate />,
  },
  // {
  //   type: "budget",
  //   name: "Budget Mapping",
  //   key: "budget",
  //   icon: <Icon fontSize="small">map</Icon>,
  //   route: "/budget",
  //   component: <Budget />,
  // },
  // {
  //   type: "budget",
  //   name: "Budget Ceilling",
  //   key: "budget-celling",
  //   icon: <Icon fontSize="small">map</Icon>,
  //   route: "/budget-celling",
  //   component: <BudgetCeiling />,
  // },

  {
    type: "collection",
    name: "Release Processing",
    key: "release-collection",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/release-collection",
    component: <ReleaseCollection />,
  },

  {
    type: "collection",
    name: "Internal Control",
    key: "internal-audit",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/internal-audit",
    component: <InternalAudit />,
  },
  {
    type: "collection",
    name: "Final Internal Controls",
    key: "internal-control",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/internal-control",
    component: <InternalControl />,
  },
  {
    // type: "collection",
    name: "Pending Approvals",
    droptype: "approval",
    key: "approval-review",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/approval-review",
    component: <ApprovalReview />,
  },
  {
    // type: "collection",
    name: "Signed Releases",
    droptype: "approval",
    key: "signed-releases",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/signed-releases",
    component: <SignedApproval />,
  },
  {
    type: "collection",
    name: "Final Approval",
    key: "final-approval",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/final-approval",
    component: <FinalApproval />,
  },
  {
    type: "collection",
    name: "Monthly Recurrent Setup",
    key: "recurrent-setup",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/recurrent-setup",
    component: <MonthlyRecurrent />,
  },
  {
    type: "collection",
    key: "recurrent-setup",
    route: "/recurrent-setup-form",
    component: <MonthlyRecurrentForm />,
  },
  {
    type: "collection",
    key: "view-release",
    route: "/view-release",
    component: <ViewRelease />,
  },

  {
    type: "collection",
    name: "Release Cancellation",
    key: "cancellation-of-release",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/cancellation-of-release",
    component: <ReleaseCancellation />,
  },

  {
    type: "collection",
    name: "Recall Release",
    key: "recall-release",
    icon: <Icon fontSize="small">undo</Icon>,
    route: "/recall-release",
    component: <RecallRelease />,
  },

  {
    type: "collection",
    name: "Unclear Release",
    key: "unclear-of-release",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/unclear-of-release",
    component: <ReleaseUnclear />,
  },

  {
    type: "planning",
    name: "Planning Reserve",
    key: "Supplimentary",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/planning-reservation",
    component: <PlanningReserve />,
  },

  {
    type: "planning",
    name: "New Virement",
    key: "new-virement",
    icon: <Icon fontSize="small">swap_horiz</Icon>,
    route: "/new-virement",
    component: <NewVirementEntry />,
  },

  {
    type: "budget",
    name: "Sector Budget Ceilling",
    key: "sector-budget-celling",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/sector-budget-celling",
    component: <SectorBudgetCeiling />,
  },

  {
    type: "budget",
    name: "MDA Budget Ceilling",
    key: "mda-budget-celling",
    icon: <Icon fontSize="small">map</Icon>,
    route: "/mda-budget-celling",
    component: <MDABudgetCelling />,
  },

  {
    key: "budget2",
    route: "/budget-form",
    component: <BudgetProposal />,
  },
  {
    key: "budget2",
    route: "/edit-new-realise-collection",
    component: <EditNewReleaseCollection />,
  },
  {
    key: "budget2",
    route: "/new-plnning-reservation",
    component: <NewPlanningReserve />,
  },
  {
    key: "budget2",
    route: "/new-realise-collection",
    component: <NewReleaseCollection />,
  },
  {
    type: "report",
    name: "Approved budget",
    key: "approved-budget",
    icon: <Icon fontSize="small">work</Icon>,
    route: "/approved-budget",
    component: <ApprovedBudget />,
  },
  {
    type: "report",
    name: "Budget Report Tracker",
    key: "budgets-tracker",
    icon: <Icon fontSize="small">directions</Icon>,
    route: "/budgets-tracker",
    component: <BudgetView />,
  },

  {
    type: "report",
    name: "Publication Reports",
    key: "publication-reports",
    icon: <Icon fontSize="small">book</Icon>,
    route: "/publication-reports",
    component: <PublicationReportsNew />,
  },

  {
    type: "report",
    name: "Appropriation Law",
    key: "appropriation-law",
    icon: <Icon fontSize="small">book</Icon>,
    route: "/appropriation-law",
    component: <AppropriationLaw />,
  },

  {
    type: "report",
    name: "Budget Overview",
    key: "budget-overview",
    icon: <Icon fontSize="small">loyalty</Icon>,
    route: "/budget-overview",
    component: <BudgetOverview />,
  },
  {
    type: "report",
    name: "Budget Performance",
    key: "budget-performance",
    icon: <Icon fontSize="small">loyalty</Icon>,
    route: "/budget-performance",
    component: <BudgetPerformance />,
  },
  {
    type: "report",
    name: "Revenue Reports",
    key: "revenue-reports",
    droptype: "revenue-reports",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/revenue-reports",
    component: <RevenueReportsDash />,
  },

  // {
  //   type: "report",
  //   name: "Receipt Revenue by Fund",
  //   key: "receipt-revenue-by-fund",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/receipt-revenue-by-fund",
  //   component: <ProgramQuaterly />,
  // },
  {
    type: "report",
    name: "Release Report",
    key: "release_report",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/release_report",
    component: <ReleaseReport />,
  },
  {
    type: "report",
    name: "Revenue Reports by Admin",
    key: "total-revenue-by-admin",
    droptype: "revenue-reports",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/total-revenue-by-admin",
    component: <AdminQuaterly />,
  },

  {
    type: "report",
    name: "Total Revenue by Economic",
    droptype: "revenue-reports",
    key: "total-revenue-by-economic",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/total-revenue-by-economic",
    component: <TotalRevenuebyEconomic />,
  },
  {
    type: "report",
    name: "Capital Receipts by item",
    droptype: "revenue-reports",
    key: "capital-recepts-by-item",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/capital-recepts-by-item",
    component: <FuncQuaterly />,
  },

  {
    type: "report",
    name: "Budget Entries Excel Report",
    droptype: "revenue-reports",
    key: "budget-entries-excel-report-revenue",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/budget-entries-excel-report",
    component: <BudgetEntriesReport />,
  },

  {
    type: "report",
    name: "Total Revenue by Fund",
    key: "total-revenue-by-fund",
    droptype: "revenue-reports",
    icon: <Icon fontSize="small">location_on</Icon>,
    route: "/total-revenue-by-fund",
    component: <ProgramReport />,
  },

  // {
  //   type: "report",
  //   name: "Capital Receipts by Fund",
  //   key: "capital-receipts-by-fund",
  //   droptype: "revenue-reports",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/capital-receipts-by-fund",
  //   component: <FundReport />,
  // },
  // {
  //   type: "report",
  //   name: "Capital Expenditure",
  //   droptype: "expenditure",
  //   key: "capital-expenditure",
  //   icon: <Icon fontSize="small">code</Icon>,
  //   route: "/capital-expenditure",
  //   component: <EcoQuaterly />,
  // },
  {
    type: "report",
    name: "Expenditure Reports",
    droptype: "expenditure",
    key: "exp-by-mda",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/exp-by-mda",
    component: <Report />,
  },
  {
    type: "report",
    name: "Expenditure by Admin",
    droptype: "expenditure",
    key: "expenditure-reports-by-admin",
    icon: <Icon fontSize="small">monetization_on</Icon>,
    route: "/expenditure-reports-by-admin",
    component: <EcoReport />,
  },

  {
    type: "report",
    name: "Expenditure by Department",
    droptype: "expenditure",
    key: "expenditure-reports-by-department",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expenditure-reports-by-department",
    component: <ExpByDepartment />,
  },

  {
    type: "report",
    name: "Budget Entries Excel Report",
    droptype: "expenditure",
    key: "budget-entries-excel-report",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/budget-entries-excel-report",
    component: <BudgetEntriesReport />,
  },

  // {
  //   type: "report",
  //   name: "Personnel Exp by Admin",
  //   droptype: "expenditure",
  //   key: "personnel-exp-by-admin-report",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/personnel-exp-by-admin-report",
  //   component: <GeoReport />,
  // },
  {
    type: "report",
    name: "Exp by Programme",
    droptype: "expenditure",
    key: "exp_by_prog",
    icon: <Icon fontSize="small">code</Icon>,
    route: "/exp_by_prog",
    component: <ProgramQuaterly />,
  },
  {
    type: "report",
    name: "Exp by Location",
    droptype: "expenditure",
    key: "exp_by_loc",
    icon: <Icon fontSize="small">location_on</Icon>,
    route: "/exp_by_loc",
    component: <ReportByLoc />,
  },
  {
    type: "report",
    name: "Revenue by MDA",
    droptype: "revenue-reports",
    key: "revenue-by-mda",
    icon: <Icon fontSize="small">summarize</Icon>,
    route: "/revenue-by-mda",
    component: <RevenueByMDA />,
  },
  {
    type: "report",
    name: "Expenditure By MDA",
    droptype: "expenditure",
    key: "exp-by-mda-report",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/exp-by-mda-report",
    component: <GeoReport />,
  },

  {
    type: "report",
    name: "Exp by Fund",
    droptype: "expenditure",
    key: "exp_by_fund",
    icon: <Icon fontSize="small">account_balance_wallet</Icon>,
    route: "/exp_by_fund",
    component: <ReportByFund />,
  },
  {
    type: "report",
    name: "Exp by Economic",
    droptype: "expenditure",
    key: "exp_by_eco",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/exp_by_eco",
    component: <ReportByEco />,
  },
  {
    type: "report",
    name: "Exp by Function",
    key: "exp_by_func",
    droptype: "expenditure",
    icon: <Icon fontSize="small">functions</Icon>,
    route: "/exp_by_func",
    component: <ReportByFunc />,
  },

  {
    type: "report",
    name: "Expenditure by Project",
    key: "exp_by_project",
    droptype: "expenditure",
    icon: <Icon fontSize="small">functions</Icon>,
    route: "/exp_by_project",
    component: <CapitalProjects />,
  },

  // {
  //   type: "report",
  //   name: "Personnel Exp by Fund",
  //   key: "geo-report",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/geo-report",
  //   component: <GeoReport />,
  // },
  // {
  //   type: "report",
  //   name: "Personnel Exp by Fund",
  //   key: "geo-report",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/geo-report",
  //   component: <GeoReport />,
  // },

  {
    // type: "collapse",
    // name: "Form",
    key: "form",
    // icon: <Icon fontSize="small">table_view</Icon>,
    route: "/form/:id",
    component: <SegmentForm />,
  },

  {
    key: "create-user",
    // icon: <Icon fontSize="small">table_view</Icon>,
    route: "/create-user",
    component: <CreatUser />,
  },
  {
    // type: "collapse",
    // name: "Form",
    key: "form",
    // icon: <Icon fontSize="small">table_view</Icon>,
    route: "/form",
    component: <SegmentForm />,
  },
  {
    // type: "collapse",
    // name: "Form",
    key: "SignIn",
    // icon: <Icon fontSize="small">table_view</Icon>,
    route: "/SignIn",
    component: <SignIn />,
  },
  {
    key: "new-release-collection",
    route: "/edit-new-release-collection",
    component: <EditNewReleaseCollection />,
  },
  // {
  //   // type: "collapse",
  //   // name: "Form",
  //   key: "sign-up",
  //   // icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/sign-up",
  //   component: <SignUp />,
  // },
  {
    type: "sub",
    name: "Sub Table",
    key: "sub-org",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/sub-org",
    component: <Profile />,
  },
  {
    type: "sub",
    name: "Sub Sub Table",
    key: "sub-sub-org",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/sub-sub-org",
    component: <SubSubOrg />,
  },
  {
    type: "sub",
    name: "Sub Sub Sub Table",
    key: "sub-sub-sub-org",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/sub-sub-sub-org",
    component: <SubSubSubOrg />,
  },
  {
    type: "budget_type",
    name: "Proposed Budget",
    key: "budget2",
    icon: <Icon fontSize="small">reorder</Icon>,
    route: "/budget2",
    component: <Proposedtable />,
  },

  {
    type: "budget_type",
    name: "MOPB Recommendation",
    key: "mopb",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/mopb",
    component: <MOPB />,
  },
  {
    type: "budget_type",
    name: "Exco Recommendation",
    key: "Exco",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/Exco",
    component: <EXCO />,
  },
  {
    type: "budget_type",
    name: "House Recommendation",
    key: "House",
    icon: <Icon fontSize="small"> house </Icon>,
    route: "/House",
    component: <HouseRecom />,
  },
  {
    type: "budget_type",
    name: "Approve Recommendation",
    key: "Approve",
    icon: <Icon fontSize="small">checkbox-marked </Icon>,
    route: "/Approve",
    component: <Approved />,
  },
  {
    type: "budget_type",
    name: "Budget Breakdown",
    key: "BudgetBreakdown",
    icon: <Icon fontSize="small">reorder</Icon>,
    route: "/BudgetBreakdown",
    component: <BudgetBreakdown />,
  },
  {
    // type: "report",
    // name: "Release Report",
    key: "release_view",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/release_view",
    component: <ReleaseView />,
  },

  {
    type: "budget_type",
    name: "Revised Estimate",
    key: "Revised",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/Revised",
    component: <Revised />,
  },

  {
    type: "mapping",
    name: "MDA Mapping",
    key: "admin-maping",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/admin-maping",
    component: <AdminMapping />,
  },
  {
    type: "mapping",
    name: "Economic Segment Mapping",
    key: "economic-mapping",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/economic-mapping",
    component: <EcoMapping />,
  },
  {
    type: "mapping",
    name: "Functional Segment Mapping",
    key: "functional-maping",
    icon: <Icon fontSize="small">money</Icon>,
    route: "/functional-maping",
    component: <FuncMap />,
  },
  {
    type: "mapping",
    name: "Programme Segment Mapping",
    key: "program-maping",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/program-maping",
    component: <ProgramMaping />,
  },
  {
    type: "mapping",
    name: "Fund Segment Mapping",
    key: "fund-mapping",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/fund-mapping",
    component: <FundMaping />,
  },
  {
    type: "mapping",
    name: "Geo Segment Mapping",
    key: "geo-maping",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/geo-maping",
    component: <GeoMaping />,
  },

  {
    type: "m&e",
    name: "Agriculture Sector",
    key: "agric-sector",
    icon: <Icon fontSize="small">agriculture</Icon>,
    route: "/agric-sector",
    component: <AgricultureSector />,
  },

  {
    type: "m&e",
    name: "Commerce Sector",
    key: "commerce-sector",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/commerce-sector",
    component: <CommerceSector />,
  },

  {
    type: "m&e",
    name: "Education Sector",
    key: "education-sector",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/education-sector",
    component: <EducationSector />,
  },

  {
    type: "m&e",
    name: "Natural Resource Sector",
    key: "natural-resource-sector",
    icon: <Icon fontSize="small">nature</Icon>,
    route: "/natural-resource-sector",
    component: <EnvironmentNaturalResourcesSector />,
  },

  {
    type: "m&e",
    name: "Health Sector",
    key: "health-sector",
    icon: <Icon fontSize="small">local_hospital</Icon>,
    route: "/health-sector",
    component: <HealthSector />,
  },

  {
    type: "m&e",
    name: "Housing and Transport Sector",
    key: "housing-transport-sector",
    icon: <Icon fontSize="small">house</Icon>,
    route: "/housing-transport-sector",
    component: <HousingandTransportSector />,
  },
  {
    type: "m&e",
    name: "State M&E",
    key: "state-me",
    icon: <Icon fontSize="small">location_city</Icon>,
    route: "/state-me",
    component: <KanoStateMandE />,
  },
  // {
  //   type: "m&e",
  //   name: "Sample Monitoring",
  //   key: "sample-monitor",
  //   icon: <Icon fontSize="small">insights</Icon>,
  //   route: "/sample-monitor",
  //   component: <SampleMonitoring />,
  // },

  {
    type: "new_admin",
    name: "User Management",
    key: "manage-user",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/manage-user",
    component: <ManageUser />,
  },
  {
    type: "new_admin",
    name: "Audit Trail",
    key: "audit-trail",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/audit-trail",
    component: <AuditTrail />,
  },
  {
    type: "new_admin",
    name: "Other Setup",
    key: "other-set-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/other-set-up",
    component: <OtherSetup />,
  },

  {
    type: "new_admin",
    name: "Upload Budget",
    key: "udget-upload",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/budget-upload",
    component: <ExcelUpload />,
  },

  // Memo Routes
  {
    type: "memo",
    name: "Secretary",
    key: "memo-secretary",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/memo-secretary",
    component: <Secretary />,
  },
  {
    type: "memo",
    name: "Commissioner",
    key: "memo-commissioner",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/memo-commissioner",
    component: <Commissioner />,
  },
  {
    type: "memo",
    name: "Pam-sec",
    key: "memo-pamsec",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/memo-pamsec",
    component: <PamSec />,
  },
  {
    type: "memo",
    name: "Director",
    key: "memo-director",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/memo-director",
    component: <Director />,
  },
  {
    key: "memo-list",
    route: "/memo-list",
    component: <MemoList />,
  },
  {
    key: "create-memo",
    route: "/create-memo",
    component: <CreateMemo />,
  },
  {
    key: "view-memo",
    route: "/view-memo",
    component: <ViewMemo />,
  },
];

export default routes;
